export default __webpack_public_path__ + "static/media/icon-feature.d4944008.svg";